import { createContext } from "react";

// Book context
export const VfContext = createContext();
